import axios from "axios";
export default {
  OilInit: async (IP, port) => {
    try {
      let response = await axios.get(`https://${IP}:${port}/init_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  OilGetData: async (IP, port) => {
    try {
      let response = await axios.get(`https://${IP}:${port}/get_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  getDeviceStatus: async (IP, port) => {
    try {
      let response = await axios.get(`https://${IP}:${port}/device/status`);
      return response.data;
    } catch (err) {
      return err.response ? err.response.data : { message: "Request failed" };
    }
  },

  getDeviceConnectStatus: async (IP, port) => {
    try {
      let response = await axios.get(`https://${IP}:${port}/device/connect_status`);
      return response.data;
    } catch (err) {
      return err.response ? err.response.data : { message: "Request failed" };
    }
  },

  controlDevice: async (IP, port, command) => {
    try {
      let response = await axios.post(
        `https://${IP}:${port}/device/control`,
        { command: command }
      );
      return response.data;
    } catch (err) {
      return err.response ? err.response.data : { message: "Request failed" };
    }
  },
};